import { PostTypeContext } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

import { useI18n } from '../../i18n/providers/I18nProvider.js'
import { CommandBarHookResult, emptyCommandBarResult } from '../types.js'

export const useCommandBarPosts: CommandBarHookResult = () => {
  const { $t } = useI18n()
  const { data: network } = useNetwork()

  const availablePostTypes = network?.postTypes?.filter(
    postType =>
      postType?.authMemberProps?.availableSpaces?.length > 0 &&
      postType?.context === PostTypeContext.post &&
      postType?.slug !== 'tribe-message' &&
      !postType?.archived,
  )

  if (!availablePostTypes?.length) {
    return emptyCommandBarResult
  }

  const categoryTexts = {
    newPost: $t({
      id: 'Generics.NewPost',
      defaultMessage: 'New post',
    }),
  } as const

  return {
    actions: [
      {
        name: $t({
          id: 'CommandBar.Posts.CreateNewPost',
          defaultMessage: 'Create new post',
        }),
        url: '/new',
        icon: 'plus',
        category: categoryTexts.newPost,
        hotkey: 'n',
      },
      ...availablePostTypes?.map(postType => {
        return {
          name: $t(
            {
              id: 'CommandBar.Posts.CreateNewPostWithType',
              defaultMessage: 'Create new {post_type_name}',
            },
            { post_type_name: postType.name.toLowerCase() },
          ),
          url: `/new?post_type=${postType.id}`,
          icon: 'plus',
          category: categoryTexts.newPost,
        }
      }),
    ],
  }
}
